export const SET_SUPPORT_ARTICLE_DETAILS = 'SET_SUPPORT_ARTICLE_DETAILS';
export const setSupportArticleDetails = article => ({
  type: SET_SUPPORT_ARTICLE_DETAILS,
  article,
});

export const SET_SUPPORT_SELECTED_ARTICLE_SLUG = 'SET_SUPPORT_SELECTED_ARTICLE_SLUG';
export const setSupportSelectedArticleSlug = slug => ({
  type: SET_SUPPORT_SELECTED_ARTICLE_SLUG,
  slug,
});

export const SET_REFERRAL_PAGE = 'SET_REFERRAL_PAGE';
export const SET_REFERRAL_INFO = 'SET_REFERRAL_INFO';
export const PAYMENT_REQUEST_ATTEMPT = 'PAYMENT_REQUEST_ATTEMPT';
export const PAYPAL_REQUEST = 'PAYPAL_REQUEST';



// WEBPACK FOOTER //
// ./app/actions/support.js